import { useLocation } from 'react-router';

import {
  BASIC_DATA_TABLE_DISPLAY_ROWS,
  SHARED_DASHBOARD_PATH
} from '@/features/Dashboard/constants/const';

import CommoditiesTableTab from './CommoditiesTableTab';

import type { CommoditiesTableSectionType } from '../types';

const CommoditiesTable = ({
  layout,
  sections
}: {
  sections: CommoditiesTableSectionType[] | undefined;
  layout?: { fullWidth?: boolean; height?: number };
}) => {
  const { pathname } = useLocation();
  const isDashboard = pathname.startsWith('/dashboard') || pathname === SHARED_DASHBOARD_PATH;
  const height = layout?.height ?? (isDashboard ? BASIC_DATA_TABLE_DISPLAY_ROWS : undefined);

  return (
    sections && (
      <CommoditiesTableTab
        height={height}
        sections={sections}
      />
    )
  );
};

export default CommoditiesTable;
